/**
 * Single source of truth for fabric capture guardrails (tunable per environment).
 * TODO: load from remote config / feature flags for A/B tuning.
 */

export const FABRIC_CAPTURE_THRESHOLDS = {
  /** Fabric region covers more than this fraction of the frame → too close / over-zoomed */
  tooCloseCoverageThreshold: 0.85,
  /** Ideal framing lower bound (inclusive) */
  idealMinCoverage: 0.55,
  /** Ideal framing upper bound (inclusive) */
  idealMaxCoverage: 0.75,
  /** Below this coverage → too far / fabric too small */
  tooFarCoverageThreshold: 0.4,

  /** Mean luminance 0–1; below = low light */
  minBrightnessThreshold: 0.22,
  /** Laplacian variance on downscaled grayscale; below = likely blurry (device-tunable) */
  minSharpnessThreshold: 18,

  /** Border margin: if fabric bbox touches within this fraction of an edge, warn cutoff */
  edgeCutoffMarginRatio: 0.03,

  /**
   * Cheap alignment proxy: horizontal offset of fabric centroid from frame center (0–0.5).
   * Above → suggest re-centering / tilt. TODO: replace with homography / line detection (ML).
   */
  maxCentroidOffsetRatio: 0.18,

  /** Live preview analysis: max width of working canvas (performance) */
  analysisMaxWidth: 200,

  /** Minimum detector confidence before trusting coverage for strict readiness */
  minDetectorConfidenceForReady: 0.35,
};
